import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { Text } from 'components/chroma';

export const RentalAgreementInfoModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <Modal header="What is a rental agreement?" isOpen={isOpen} onClose={onClose}>
    <Text>
      A rental agreement is a current valid written agreement for tenancy of
      your property between you and the tenant for a period of no less than 3
      months. It should include the rental period, the amount of rent and the
      amount of bond a tenant is required to pay. It also includes an extension
      of the rental agreement by way of periodic tenancy that immediately
      follows the expiration of the agreement on the terms set out in the lease.
    </Text>
  </Modal>
);

export default RentalAgreementInfoModal;
